var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33508 19.0492V18.7572C5.37792 17.8933 5.65478 17.0563 6.13713 16.3325C6.93999 15.463 7.48959 14.3974 7.72827 13.2476C7.72827 12.359 7.72827 11.4577 7.80589 10.569C8.20691 6.2909 12.437 3.33301 16.6154 3.33301H16.7189C20.8973 3.33301 25.1274 6.2909 25.5413 10.569C25.6189 11.4577 25.5413 12.359 25.606 13.2476C25.8479 14.4001 26.3969 15.4689 27.1971 16.3452C27.6831 17.0626 27.9604 17.8966 27.9992 18.7572V19.0365C28.0281 20.1971 27.6283 21.3288 26.8737 22.2229C25.8766 23.2683 24.5235 23.9187 23.0705 24.0509C18.81 24.5079 14.5114 24.5079 10.2508 24.0509C8.79951 23.913 7.44833 23.2635 6.44759 22.2229C5.70465 21.3281 5.31031 20.2031 5.33508 19.0492Z",
    stroke: "#FFAF80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 28.4683C14.0719 29.3038 15.0495 29.8446 16.1226 29.9709C17.1957 30.0971 18.2759 29.7985 19.124 29.1411C19.3849 28.9466 19.6196 28.7206 19.8226 28.4683",
    stroke: "#FFAF80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6654,
    cy: 7.33285,
    r: 5.33333,
    fill: "#FF4D5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/Notification_icon.1fa2558e4f5f485203aa61cd566e2036.svg";
export { ForwardRef as ReactComponent };